import React from 'react'
import { sortableHandle } from 'react-sortable-hoc'
import SortHandler from '../icon/sortHandler'
import './SortableHandle.scss'

const DragHandle = sortableHandle(() => {
  return (
    <div className="sortable-handle">
      <SortHandler />
    </div>
  )
})

export default DragHandle
